import CometMarquee from 'comet-marquee';
// import 'comet-marquee/dist/comet-marquee.css';

const highlightsMarqueeArr = document.querySelectorAll('.highlights-marquee');
highlightsMarqueeArr.forEach((highlightsMarqueeEl, i) => {
  const highlightsMarquee = new CometMarquee(highlightsMarqueeEl, {
    speed: 40,
    pauseOnHover: true,
    initialShift: window.innerWidth >= 1033,
    pauseOnInvisible: true,
    syncPause: false,
    repeatCount: 5,
    forceAnimation: window.innerWidth >= 1033,
    forceAnimationWidth: window.innerWidth >= 1033 ? 3 : false,
    fullWidth: window.innerWidth >= 1033,
  });
})